import { EmployerPaymentMethodType } from "../../models/funding/employerPaymentMethod";

export const topUpEmployerFund = async ({
    amountWithSurcharge,
    employerPaymentMethodId,
    employerPaymentMethodType,
    reference,
    API_URL,
    token,
    employerId,
    employerFundId
  }: {
    amountWithSurcharge: number;
    employerPaymentMethodId?: string;
    employerPaymentMethodType: EmployerPaymentMethodType;
    reference?: string;
    API_URL: string;
    token: string;
    employerId: string;
    employerFundId: string;
  }) => {
    const response = await fetch(`${API_URL}/employers/${employerId}/employer-funds/${employerFundId}/top-ups`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
        body: JSON.stringify({
            amountWithSurcharge,
            employerPaymentMethodId,
            employerPaymentMethodType,
            reference:
              employerPaymentMethodType ===
              EmployerPaymentMethodType.PURCHASE_ORDER
                ? reference
                : undefined
            })
    });

    return response.json();
}